import { apiGet, apiPost, unwrap } from './apiClient';
import type {
  ResponseDTO,
  PayloadSummary,
  SchemaResponse,
  ValidationResponse,
} from '@/types/api';

const BASE = '/api/v1/apple/mdm/payloads';

export async function listPayloads() {
  const res = await apiGet<ResponseDTO<PayloadSummary[]>>(
    BASE,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function getPayloadSchema(kind: string, identifier: string) {
  const res = await apiGet<ResponseDTO<SchemaResponse>>(
    `${BASE}/${kind}/${identifier}/schema`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function validatePayload(
  kind: string,
  identifier: string,
  config: Record<string, unknown>
) {
  const res = await apiPost<ResponseDTO<ValidationResponse>>(
    `${BASE}/${kind}/${identifier}/validate`,
    config,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
